import { render, staticRenderFns } from "./BrandsByBrandTypeDonutChart.vue?vue&type=template&id=45892501&scoped=true&"
import script from "./BrandsByBrandTypeDonutChart.vue?vue&type=script&lang=ts&"
export * from "./BrandsByBrandTypeDonutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45892501",
  null
  
)

export default component.exports